import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pHeadBtns",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "pHeadBtns-main"
  }, [!_vm.isMobile ? _c('div', {
    staticClass: "btn pHeadBtns-btn",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/launch');
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang("Launch Token")))]) : _vm._e(), !_vm.address ? _c('div', {
    staticClass: "btn pHeadBtns-wallet",
    on: {
      "click": _vm.web3Connect
    }
  }, [_vm.btnWalletLoading ? _c('div', {
    staticClass: "btnLoading",
    class: _vm.isMobile && 'wap'
  }) : [_vm._v(" " + _vm._s(_vm.$lang("Connect wallet")) + " ")]], 2) : _c('div', {
    staticClass: "btns pHeadBtns-wallet",
    on: {
      "click": () => _vm.pWalletMenuShow = true
    }
  }, [_vm.web3Wallet.icon ? _c('img', {
    attrs: {
      "src": _vm.web3Wallet.icon,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("fmt_addr")(_vm.address, 10)) + " "), _c('svg-icon', {
    attrs: {
      "name": "icon-arrow"
    }
  }), _vm.pWalletMenuShow ? [_c('p-wallet-menu')] : _vm._e()], 2)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };